import { 
  getDingTalkApplyList, 
  refuseApplication, 
  agreeSyncApply, 
  resyncApply,
  getDingTalkApplyStatusList,
  relateCorpApply,
} from '../services';
import { getInstitutionList } from '@/routes/ExecutionUnit/services';

  
export default {
  namespace: 'dingTalkExecute',
  state: {},
  effects: {
    * getDingTalkApplyList ({ payload }, { call }) {
      const res = yield call(getDingTalkApplyList, payload);
      return res;
    },
    * refuseApplication ({ payload }, { call }) {
      const res = yield call(refuseApplication, payload);
      return res;
    },
    * agreeSyncApply ({ payload }, { call }) {
      const res = yield call(agreeSyncApply, payload);
      return res;
    },
    * resyncApply ({ payload }, { call }) {
      const res = yield call(resyncApply, payload);
      return res;
    },
    * relateCorpApply ({ payload }, { call }) {
      const res = yield call(relateCorpApply, payload);
      return res;
    },
    * getDingTalkApplyStatusList ({ payload }, { call }) {
      const res = yield call(getDingTalkApplyStatusList, payload);
      return res;
    },
    * getInstitutionList ({ payload }, { call }) {
      const res = yield call(getInstitutionList, payload);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
